'use client';

import Editor from '@monaco-editor/react';
import { MinimalTemplate, } from '@payloadcms/next/templates';
import { Button, useModal, useTheme, XIcon } from '@payloadcms/ui';
import React from 'react';
import { options } from '../../options';
import './CustomThemeDescriptionModal.scss';

export const CustomThemeDescriptionModal: React.FC<{ modalId: string, value: any }> = ({ modalId, value }) => {
  // const { t } = useTranslation();
  const { closeModal } = useModal();
  const { theme } = useTheme();
  const onClose = () => {
    console.log('onClose', modalId);
    closeModal(modalId);
  };
  const classes = '';
  const readOnly = true;
  const defaultTheme = options.defaultTheme || {};
  return (
    <MinimalTemplate width="wide">
      <div className={'custom-theme-description-modal'}>
        <header className={'custom-theme-description-modal__header'}>
          <h3>
            <span>Custom theme full specs</span>
          </h3>
          <Button buttonStyle="none" onClick={onClose}><XIcon /></Button>
        </header>
        <main className={'custom-theme-description-modal__main'}>
          <Editor
            className={classes}
            height="80vh"
            loading={<>loading...</>}
            options={{
              detectIndentation: true,
              minimap: {
                enabled: false,
              },
              readOnly: Boolean(readOnly),
              scrollBeyondLastLine: false,
              tabSize: 2,
              wordWrap: 'on',
            }}
            theme={theme === 'dark' ? 'vs-dark' : 'vs'}
            value={value ? JSON.stringify(defaultTheme, null, 2) : ''}
            language="json"
          />
        </main>
      </div>
    </MinimalTemplate>
  );
};
